import React from 'react';

import HomeApp from './components/home-app';
import WithQuery from '../../../../common/components/with-query';

const Home = props => {
  return (
    <WithQuery query={props.location.search}>
      <HomeApp />
    </WithQuery>
  );
}

export default Home;
